import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import {
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
} from '@angular/common/http';

// MSAL imports
import { MsalGuard, MsalInterceptor, MsalModule } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {
  msalConfig,
  protectedCDMServiceResources,
  protectedDataEntryServiceResources,
  protectedDotnetResources,
} from './auth-config';

// Angular Material imports
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { GlobalErrorHandler } from './core/errorhandlers/apm-error-handler';
import { ApmModule } from '@elastic/apm-rum-angular';
import { CustomApmService } from './core/services/apm.service';
import { environment } from '../environments/environment';
import { CorrelationIdInterceptor } from './core/services/correlation-id.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    importProvidersFrom(
      MatButtonModule,
      MatToolbarModule,
      MatListModule,
      MatTableModule,
      MsalModule.forRoot(
        new PublicClientApplication(msalConfig),
        {
          interactionType: InteractionType.Redirect,
          authRequest: {},
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            [
              `${environment.ONECUSTOMER_BASE_URL}`,
              protectedDotnetResources.scopes,
            ],
            [
              `${environment.DATA_EDITOR_SERVICE.BASE_URL}`,
              protectedDataEntryServiceResources.scopes,
            ],
            [
              `${environment.CDM_SERVICE.BASE_URL}`,
              protectedCDMServiceResources.scopes,
            ],
          ]),
        },
      ),
      ApmModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorrelationIdInterceptor,
      multi: true,
    },
    MsalGuard,
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler,
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: (apmService: CustomApmService) => () =>
        apmService.initializeApm(),
      deps: [CustomApmService],
      multi: true,
    },
    provideNativeDateAdapter(),
  ],
};
